import {
  FocusContext,
  updateAllLayouts,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import _ from "lodash";
import { ShowCaseComponentSwitch } from "../showcase/showcase.utils";
import smoothScroll from "../../utils/animateScroll";
import { getVerticalFocusScrollTarget } from "../../utils/focusScroll";
import httpService from "../../services/http.service";
import { getCMSApiRoute } from "../../utils/api.utils";
import { anavatanCities } from "../../config/enums";
import { MoviesSlider } from "./moviesList";
import LazyRow from "../common/LazyRow";
import { useInputMode } from "../../utils/hooks/useInputMode";

const DisabledHeadContent = ({ states }) => (
  <div className="legacy-anavatan-head legacy-anavatan-head-disabled" aria-disabled="true">
    <div className="legacy-anavatan-head-title-row">
      <img className="legacy-anavatan-iran-icon" src="iran.svg" alt="iran" draggable="false" />
      <h2 className="legacy-anavatan-head-title">آناوطن</h2>
    </div>
    <p className="legacy-anavatan-head-subtitle">محتوای استان خود را تماشا کنید.</p>
    <div>
      <div className="legacy-anavatan-head-scroller legacy-anavatan-head-scroller-disabled">
        <div className="legacy-anavatan-head-scroll-content">
          {states?.map((state) => (
            <button
              type="button"
              disabled
              tabIndex={-1}
              className={"legacy-anavatan-head-button legacy-anavatan-head-button-disabled " + (state.style || "")}
              key={state.id}
            >
              {state.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  </div>
);

// ============================================================================
// MAIN COMPONENT
// ============================================================================

const AnavatanContent = ({ showCaseData = {} }) => {
  const { ref, focusKey } = useFocusable({
    focusKey: "anavatan_content",
  });
  const [selectedCity, setSelectedCity] = useState(null);
  const [cityData, setCityData] = useState(null);
  const [loading, setLoading] = useState(false);
  const skipNextScrollRef = React.useRef(false);

  useEffect(() => {
    if (selectedCity && selectedCity !== "default") {
      setLoading(true);
      // Set flag to skip scroll on next focus after data loads
      skipNextScrollRef.current = true;
      const fetchCityData = async () => {
        try {
          const response = await httpService.get(
            getCMSApiRoute("province-content"),
            {
              params: {
                province: selectedCity,
              },
            }
          );

          const data = response.data?.data;

          let res = [];

          for (let city of data) {
            if (city.contents?.length > 0) {
              res.push({
                ...city,
                contents: city.contents?.reduce(
                  (acc, i) => acc.concat({ content: i }),
                  []
                ),
              });
            }
          }
          setCityData(res); // Set fetched data
        } catch (error) {
          setCityData([]); // Set empty array if error
          console.error("Error fetching city data:", error);
        } finally {
          setLoading(false);
          updateAllLayouts();
        }
      };

      fetchCityData();
    }
  }, [selectedCity]);

  // Reset scroll to top when cityData changes (new content loaded)
  useEffect(() => {
    if (cityData && ref.current) {
      ref.current.scrollTop = 0;
    }
  }, [cityData, ref]);

  const { isMouseFocus } = useInputMode();
  const onRowFocus = useCallback(
    (props) => {
      if (isMouseFocus) return;
      const targetScroll = getVerticalFocusScrollTarget(ref.current, props || {}, {
        topPadding: 88,
        bottomPadding: 128,
      });

      smoothScroll(ref, targetScroll, 500);
    },
    [ref, isMouseFocus]
  );

  const data = useMemo(() => {
    let results = [];

    Object.keys(showCaseData)?.map((key) =>
      showCaseData[key]?.map((item) => results.push(item))
    );

    return _.sortBy(results, (x) => x.priority);
  }, [showCaseData]);

  return (
    <div className="legacy-anavatan-content-wrapper">
      <FocusContext.Provider value={focusKey}>
        <div className="legacy-anavatan-scroll-rows" ref={ref}>
          <div>
            <DisabledHeadContent
              states={anavatanCities}
              onFocus={onRowFocus}
              setSelectedCity={setSelectedCity}
              selectedCity={selectedCity}
            />
            {/* {loading && (
                <div className="legacy-anavatan-loading">
                <div className="legacy-anavatan-spinner" />
              </div>
            )}
            {!loading && (
              <div>
                {(data?.length > 0 && !selectedCity) ||
                  selectedCity === "default" ? (
                  data?.map((item, index) => (
                    <ShowCaseComponentSwitch
                      key={"sc_av_" + item._id}
                      item={item}
                      onRowFocus={onRowFocus}
                      parentIndex={index}
                    />
                  ))
                ) : cityData && cityData?.length > 0 ? (
                  cityData?.map(
                    (item, index) =>
                      item.contents.length > 0 && (
                        <LazyRow key={'city_row_' + index} index={index}>
                          <MoviesSlider
                            movies={item.contents}
                            onFocus={onRowFocus}
                            rowTitle={item.name}
                            shapeType={"movie"}
                            id={'city_row_' + index}
                            index={index}
                            cityKey={item.name}
                            provinceKey={selectedCity !== "default" ? selectedCity : null}
                          />
                        </LazyRow>
                      )
                  )
                ) : (
                  <div className="legacy-anavatan-empty">
                    <p className="legacy-anavatan-empty-text">محتوایی یافت نشد.</p>
                  </div>
                )}
              </div>
            )} */}

            <div className="flex flex-col justify-center items-center w-full min-h-[50vh] text-white">
              <h4 className="text-2xl font-medium">به زودی ...</h4>
              <p>بخش آناوطن به زودی در دسترس خواهد بود</p>
            </div>
          </div>
        </div>
      </FocusContext.Provider>
    </div>
  );
};

export default AnavatanContent;
